import { ELeaveContactsActions } from '../../constants/actionTypes/leaveContactsModal';
import { TReduxActions } from '../../types/redux';
import { ILeaveContactsState } from '../../types/redux/leaveContacts';

export const leaveContactsModalDefaultState = {
  isOpened: false,
};

export function leaveContactsModalReducer(
  state: ILeaveContactsState = leaveContactsModalDefaultState,
  action: TReduxActions,
): ILeaveContactsState {
  switch (action.type) {
    case ELeaveContactsActions.open:
      return {
        ...state,
        isOpened: true,
      };

    case ELeaveContactsActions.close:
      return {
        ...state,
        isOpened: false,
      };

    default:
      return state;
  }
}
